/* tslint:disable */
/* eslint-disable */
/**
 * Backbone API
 * <strong>Using API Key Authentication</strong>        <br /><br /> <p>To authenticate with the api key:</p>        <pre>       curl --location --request POST \'https://prod-api.backboneapp.co/api/v2/users/login\'       --header \'x-api-key: {API-KEY}\'       --header \'Content-Type: application/json\'       </pre>       <p>Each following request:</p>       <pre>       curl --location --request GET \'https://prod-api.backboneapp.co/api/v2/products\'       --header \'x-api-key: {API-KEY}\'       --header \'Content-Type: application/json\'       --header \'authentication: {\'token\' from the login route response}\'        </pre>
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: AxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}
